/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-05 11:29:10
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { Collapse } from 'react-collapse';
import { Icon } from '@shopify/polaris';
import classnames from 'classnames';
import { CaretDownMinor, ViewMinor, HideMinor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import MenuItem from 'src/components/views/theme-settings/collapse/menu-item';
import { TYPE_UPDATE_SETTING } from 'src/constants/theme-settings';

type State = {
  isOpenCollapse: boolean
};

type Props = {
  id: string,
  title: string,
  icon: any,
  isCollapsible: boolean,
  activeMenuItem: string,
  updateType: string,
  children: any[],
  isHidden?: boolean,
  subMenu: any[],
  menus?: any[],
  updateField: Function,
  formValues: any,
  themeSettingDefaultValue: any,
  themeSettingDefaultThemeValue: any,
  handleChangeActiveMenuItem: (id: string, updateType: string) => void,
  handleUpdateMenuSetting: (id: string, children: any[], updateType: string) => void,
  handleToggleHideMenuItem?: (id: string, updateType: string) => void,
  upsertElementActions: (type: string, properties: Record<string, any>) => void
};

type ComposedProps = Props & WithI18nProps;

class MenuItemHasSub extends Component<ComposedProps, State> {
  state = {
    isOpenCollapse: true
  };

  handleSelectMenuItem = (id: string) => {
    const { activeMenuItem, updateType, handleChangeActiveMenuItem } = this.props;
    if (id !== activeMenuItem) {
      handleChangeActiveMenuItem(id, updateType);
    }
  };

  handleToggleCollapse = () => {
    this.setState({
      isOpenCollapse: !this.state.isOpenCollapse
    });
  };

  render() {
    const {
      i18n,
      title,
      icon,
      isCollapsible,
      id,
      activeMenuItem,
      isBorder,
      isAllowHide,
      updateType,
      isHidden,
      subMenu,
      menus,
      updateField,
      formValues,
      themeSettingDefaultValue,
      themeSettingDefaultThemeValue,
      themeName,
      handleToggleHideMenuItem,
      handleChangeActiveMenuItem,
      handleUpdateMenuSetting,
      upsertElementActions,
      removeCurrentElement,
      updateFieldReducer
    } = this.props;
    const { isOpenCollapse } = this.state;

    const menuItemClass = classnames('theme-setting-menu-item', {
      borderless: !isBorder,
      'has-submenu': !_.isEmpty(subMenu)
    });
    const caretClass = classnames('caret', { closed: !isOpenCollapse });
    const menuTitleClass = classnames('menu-title');
    const titleClass = classnames('title-wrapper', {
      active: id === activeMenuItem,
      'not-collapsible': !isCollapsible,
      disabled: isHidden
    });

    return (
      <div className={menuItemClass}>
        <div className={titleClass}>
          {isCollapsible && (
            <span className={caretClass} onClick={this.handleToggleCollapse}>
              <Icon source={CaretDownMinor} color="base" />
            </span>
          )}
          <div className="title-inner" onClick={() => this.handleSelectMenuItem(id)}>
            <span className="menu-icon">{icon}</span>
            <span className={menuTitleClass}>{i18n.translate(title)}</span>
          </div>
          {isAllowHide && (
            <span
              className="btn-view"
              onClick={e => {
                e.stopPropagation();
                handleToggleHideMenuItem(id, updateType);
              }}>
              <Icon source={isHidden ? HideMinor : ViewMinor} color="base" />
            </span>
          )}
        </div>

        {isCollapsible && (
          <Collapse isOpened={isOpenCollapse}>
            {!!subMenu?.length &&
              subMenu.map(item => (
                <MenuItem
                  {...item}
                  key={item.id}
                  activeMenuItem={activeMenuItem}
                  updateType={TYPE_UPDATE_SETTING.COMMON}
                  handleChangeActiveMenuItem={handleChangeActiveMenuItem}
                  handleUpdateMenuSetting={handleUpdateMenuSetting}
                  upsertElementActions={upsertElementActions}
                  menus={menus}
                  updateField={updateField}
                  formValues={formValues}
                  themeSettingDefaultValue={themeSettingDefaultValue}
                  themeSettingDefaultThemeValue={themeSettingDefaultThemeValue}
                  themeName={themeName}
                  removeCurrentElement={removeCurrentElement}
                  updateFieldReducer={updateFieldReducer}
                />
              ))}
          </Collapse>
        )}
      </div>
    );
  }
}

export default withI18n()(MenuItemHasSub);

MenuItemHasSub.defaultProps = {
  menus: []
};
